//component imports
import ActiveLink from "src/components/layouts/ActiveLink";

//style imports
import styles from "src/styles/components/layouts/breadcrumb.module.scss";

const BreadCrumb = (props) => {
  const lastIndex = props.breadCrumbInfo.length - 1;
  return (
    <nav aria-label="breadcrumb" className="mobNone">
      <ol className={styles.breadcrumb}>
        {props.breadCrumbInfo.map((item, val) => {
          const itemName = item.itemName || 'Unknown';  // Ensure there's always a string
          return (
            <li
              className={styles.breadcrumbItem}
              aria-current={lastIndex === val ? "page" : undefined}
              key={val}
            >
              {item.itemLink ? (
                <ActiveLink activeClassName="" href={item.itemLink} as={item.itemDirLink}>
                {itemName}
              </ActiveLink>
              
              ) : (
                itemName
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default BreadCrumb;
